import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { numberFormat } from '../../../../src/helpers/helperFunctions';
import useCcoContext from '../context/useCcoContext';

export default function TreeDataTable() {
  const { ccoData, handleViewCco, setCreateCco } = useContext(useCcoContext);

  const columns = [
    {
      field: 'customer_name',
      headerName: 'Account Name',
      width: 400,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Box>
          {row.row_type === 'parent'
            ? row.customer_name
            : row.row_type === 'child'
            ? row?.customer_name
            : numberFormat(row?.customer_name)}
        </Box>
      ),
    },
    {
      field: 'person_assigned',
      headerName: 'Person Assigned',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'past_due',
      headerName: 'Past Due',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'current',
      headerName: 'Current',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'pdc',
      headerName: 'PDC',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'total_ar',
      headerName: 'Total AR',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'credit_rating',
      headerName: 'Credit Rating',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'call_out_status',
      headerName: '',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'action',
      headerName: '',
      width: 300,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <>
          {row.row_type === 'parent' ? (
            <Button
              variant='contained'
              color='success'
              onClick={() => handleViewCco({ account_code: row?.account_code, id: null })}
            >
              Add Call Out
            </Button>
          ) : (
            ''
          )}

          {row.row_type === 'sub-child' ? (
            <Button
              variant='contained'
              color='primary'
              onClick={() => handleViewCco({ account_code: row?.account_code, id: row?.entry_id })}
            >
              View Call Out
            </Button>
          ) : (
            ''
          )}
        </>
      ),
    },
  ];

  const getTreeDataPath = (row) => row.hierarchy;
  const groupingColDef = {
    headerName: 'Account Code',
    field: 'code',
    width: 300,
    headerClassName: 'super-app-theme--header',
    valueGetter: ({ row }) => {
      if (row.row_type !== 'parent') {
        return '';
      }
      return row.code;
    },
  };

  return (
    <Box
      sx={{
        height: 800,
        width: '100%',
        '& .super-app-theme--header': {
          backgroundColor: '#6B8D3E',
          color: '#fff',
        },
        '& .child': {
          backgroundColor: '#6B8D3E',
          color: '#fff',
        },
      }}
    >
      <DataGridPro
        treeData
        loading={ccoData?.loading}
        rows={ccoData?.tableData}
        columns={columns}
        getTreeDataPath={getTreeDataPath}
        groupingColDef={groupingColDef}
        experimentalFeatures={{ rowPinning: true }}
        getRowClassName={(params) => params?.row?.row_type}
      />
    </Box>
  );
}
